import { SEEDDATA_ACCOUNT_ID_ADMIN, SEEDDATA_ACCOUNT_ID_MIA } from './internal/static-data';
export const mockedPermissionEditorModuleContext_ADMIN = {
    accountId: SEEDDATA_ACCOUNT_ID_ADMIN,
    license: undefined,
    localId: 'ari:cloud:ecosystem::extension/b726b105-b97f-4309-902b-c47864c4dc51/efeabbde-e061-434b-bfc0-6e1ab2488096/static/backend-ce-permission-editor-panel',
    cloudId: '092de6ec-9a06-485d-836e-9968962704f8',
    moduleKey: 'ce-permission-editor',
    extension: { type: 'jira:adminPage' },
};
export const mockedFieldEditorModuleContext_USER = {
    accountId: SEEDDATA_ACCOUNT_ID_MIA,
    license: undefined,
    localId: 'ari:cloud:ecosystem::extension/b726b105-b97f-4309-902b-c47864c4dc51/efeabbde-e061-434b-bfc0-6e1ab2488096/static/backend-ce-permission-editor-panel',
    cloudId: '092de6ec-9a06-485d-836e-9968962704f8',
    moduleKey: 'ce-field-editor',
    extension: {
        type: 'jira:globalPage',
    },
};
